import React, { useState, useEffect, useContext } from "react";
import { useTranslation } from 'react-i18next';
import FetchUtil from "../utils/FetchUtil";
import "../css/ListUsers.css";
import PartnerSurveyAlertReadOnlyRow from "./PartnerSurveyAlertReadOnlyRow";
import PartnerSurveyAlertTableRow from "./PartnerSurveyAlertTableRow";
import UserPartnerDD from "./UserPartnerDD";
import UserContext from "../contexts/UserContext";
import { useNavigate } from "react-router-dom";


function PartnerSurveyAlertTable({ key, setPartnerSurveyAlert, loginId, companyId, userPartnerList, setSupplierId, supplierId }) {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const [add, setAdd] = useState(false);
    const [addRowTop, setAddRowTop] = useState(false);
    const [addRowBottom, setAddRowBottom] = useState(false);
    const [error, setError] = useState("");
    const [isPartnerSurveyAlertLoading, setIsPartnerSurveyAlertLoading] = useState(false);
    const [partnerSurveyAlerts, setPartnerSurveyAlerts] = useState([]);
    const [isAppSurveyNameLoading, setIsAppSurveyNameLoading] = useState(false);
    const [appSurveyNames, setAppSurveyNames] = useState([]);
    const [count, setCount] = useState(0);
    const closeText = t("page.close");
    const userCtx = useContext(UserContext);

    const initialValues = {
        loginId: loginId,
        companyId: companyId,
        partnerKey: supplierId,
        appSurveyKey: 0,
        notCompleted: false,
        completed: false,
        highScore: false,
        takeCorrectiveAction: false,
        completedCorrectiveAction: false
    };
    const [formValues, setFormValues] = useState(initialValues);

    const resetCounter = () => {
        setCount(prevCount => prevCount + 1);
    };

    let userCompanyId = (userCtx.role !== "SiteAdmin") ? userCtx.userCompanyId : 0;
    useEffect(() => {
        fetchAppSurveyNames();
    }, []);

    useEffect(() => {
        if (supplierId > 0) {
            initialValues.partnerKey = supplierId;
            setFormValues({ ...formValues, ["partnerKey"]: supplierId });
            fetchPartnerSurveyAlerts();
        }
    }, [supplierId]);

    function fetchAppSurveyNames() {
        setError("");
        setIsAppSurveyNameLoading(true);
        const requestOptions = {
            credentials: "same-origin",
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                source: "web", getAll: false
            }),
        };
        try {
            FetchUtil.fetchAPI("GetAppSurveyNames", "/Service/StaticHelper/GetAppSurveyNames", requestOptions, retrieveAppSurveyNameSuccess, retrieveAppSurveyNameFail);
        } catch (error) {
            setIsAppSurveyNameLoading(false);
            throw new Error(error.message);
        }
    }

    function retrieveAppSurveyNameFail(redirect) {
        setIsAppSurveyNameLoading(false);
        if (redirect) {
            navigate("/");
        }
        setError(t("error.getAppSurveyFailed"));
    }

    function retrieveAppSurveyNameSuccess(responseData) {
        let getAppSurveyNameResponse;
        if (responseData) {
            getAppSurveyNameResponse = responseData.getAppSurveyNameResponse;
            if (getAppSurveyNameResponse && getAppSurveyNameResponse.errorCode === "0") {
                setAppSurveyNames(getAppSurveyNameResponse.appSurveyList.slice())
            } else if (getAppSurveyNameResponse && getAppSurveyNameResponse.errorCode === "114") {
                navigate("/", {
                    state: {
                        errorMessage: t("error.sessionTimeout"),
                    },
                });
            } else if (getAppSurveyNameResponse) {
                setError(t("error.error") + " " + getAppSurveyNameResponse.errorMessage);
            } else {
                setError(t("error.system.fetch"));
            }
        }
        setIsAppSurveyNameLoading(false);
    }

    const handleClose = (event) => {
        setPartnerSurveyAlert(false);
    };

    function fetchPartnerSurveyAlerts() {
        setError("");
        if (!initialValues.companyId || initialValues.companyId === 0
            || !initialValues.loginId || !supplierId || supplierId === 0) {
            return;
        }
        resetCounter();
        setIsPartnerSurveyAlertLoading(true);
        const requestOptions = {
            credentials: "same-origin",
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                source: "web", getAll: true,
                companyId: initialValues.companyId,
                loginId: initialValues.loginId,
                partnerKey: supplierId
            }),
        };
        try {
            FetchUtil.fetchAPI("GetUserPartnerSurveyAlerts", "/Service/PartnerSubsService/GetUserPartnerSurveyAlerts", requestOptions, retrievePartnerSurveyAlertsSuccess, retrievePartnerSurveyAlertsFail);
        } catch (error) {
            setIsPartnerSurveyAlertLoading(false);
            throw new Error(error.message);
        }
    }

    function retrievePartnerSurveyAlertsFail(redirect) {
        setIsPartnerSurveyAlertLoading(false);
        if (redirect) {
            navigate("/");
        }
        setError(t("error.partnerGetSurveyAlertFailed"));
    }

    function retrievePartnerSurveyAlertsSuccess(responseData) {
        let fetchUserPartnerSurveyAlertsResponse;
        if (responseData) {
            fetchUserPartnerSurveyAlertsResponse = responseData.fetchUserPartnerSurveyAlertsResponse;
            if (fetchUserPartnerSurveyAlertsResponse && fetchUserPartnerSurveyAlertsResponse.errorCode === "0") {
                setPartnerSurveyAlerts(fetchUserPartnerSurveyAlertsResponse.appSurveyAlertList.slice());
            } else if (fetchUserPartnerSurveyAlertsResponse && fetchUserPartnerSurveyAlertsResponse.errorCode === "114") {
                navigate("/", {
                    state: {
                        errorMessage: t("error.sessionTimeout"),
                    },
                });
            } else if (fetchUserPartnerSurveyAlertsResponse) {
                setError(t("error.error") + " " + fetchUserPartnerSurveyAlertsResponse.errorMessage);
            } else {
                setError(t("error.system.fetch"));
            }
        }
        setIsPartnerSurveyAlertLoading(false);
    }

    const handleDeleteClick = (event, partnerSurveyAlertItem, completeCallback) => {
        event.preventDefault();
        deletePartnerSurveyAlert(partnerSurveyAlertItem, completeCallback);
    };
    const deletePartnerSurveyAlert = (partnerSurveyAlertItem, completeCallback) => {
        let action = 3;
        if (partnerSurveyAlertItem.statusCode === 1) {
            action = 4;
        }
        let serverParams = {
            loginId: formValues.loginId,
            appSurveyKey: partnerSurveyAlertItem.appSurveyKey,
            partnerKey: partnerSurveyAlertItem.partnerKey,
            userCompanyId: userCompanyId,
            source: "web",
            action: action
        };
        const requestOptions = {
            credentials: "same-origin",
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(serverParams),
        };

        try {
            FetchUtil.fetchAPI("DeleteUserPartnerSurveyAlert", "/Service/PartnerSubsService/DeleteUserPartnerSurveyAlert", requestOptions, deletePartnerSurveyAlertSuccess, deletePartnerSurveyAlertFail, completeCallback);
        } catch (error) {
            setError(error.message);
            if (completeCallback) {
                completeCallback();
            }
        }
    };

    function deletePartnerSurveyAlertFail(redirect, completeCallback) {
        setError(t("error.userSurveyAlertEditFailed"));
        if (completeCallback) {
            completeCallback();
        }
    }
    function deletePartnerSurveyAlertSuccess(responseData, completeCallback) {
        let deleteUserPartnerSurveyAlertResponse;
        if (responseData) {
            deleteUserPartnerSurveyAlertResponse = responseData.deleteUserPartnerSurveyAlertResponse;
            if (deleteUserPartnerSurveyAlertResponse) {
                if (deleteUserPartnerSurveyAlertResponse.errorCode === "0") {
                    resetRowTable();
                    refreshPartnerSurveyAlert();
                } else {
                    setError(t("error.error") + " " +
                        deleteUserPartnerSurveyAlertResponse.errorMessage
                    );
                }
            }
        }
        if (completeCallback) {
            completeCallback();
        }
    }
    const addRowTableTop = () => {
        setAddRowTop(true);
        setAddRowBottom(false);
        addRowTable();
    };

    const addRowTableBottom = () => {
        setAddRowTop(false);
        setAddRowBottom(true);
        addRowTable();
    };
    const addRowTable = () => {
        setError("");
        if (!add) {
            setAdd(true);
        } else {
            setError(t("error.only1RowAllowed"));
        }

    };
    const removeRowTable = () => {
        setError("");
        resetRowTable();
    };
    const resetRowTable = () => {
        setAddRowTop(false);
        setAddRowBottom(false);
        setAdd(false);
    };
    const handleSubmit = (action, setValues, completeCallback) => {
        setError("");
        let found = false;
        if (!formValues.loginId) {
            setError(t("error.userReqd"));
            if (completeCallback) {
                completeCallback();
            }
            return false;
        }
        if (action === 1) {
            if (partnerSurveyAlerts.length > 0) {
                partnerSurveyAlerts.map((partnerSurveyAlertItem, index) => {
                    if (partnerSurveyAlertItem.appSurveyKey === setValues.appSurveyKey
                        && partnerSurveyAlertItem.partnerKey === setValues.partnerKey) {
                        setError(t("error.userSurveyAlertDup"));
                        found = true;
                        if (completeCallback) {
                            completeCallback();
                        }
                        return false;
                    }
                })
            }
            if (!found) {
                savePartnerSurveyAlert(action, setValues, completeCallback);
            } else {
                if (completeCallback) {
                    completeCallback();
                }
            }
        } else if (action === 2) {
            if (partnerSurveyAlerts.length > 0) {
                partnerSurveyAlerts.map((partnerSurveyAlertItem, index) => {
                    if (partnerSurveyAlertItem.appSurveyKey === setValues.appSurveyKey
                        && partnerSurveyAlertItem.partnerKey === setValues.partnerKey) {
                        found = true;
                    }
                })
            }
            if (found) {
                savePartnerSurveyAlert(action, setValues, completeCallback);
            } else {
                if (completeCallback) {
                    completeCallback();
                }
            }
        } else if (completeCallback) {
            completeCallback();
        }
    };
    const savePartnerSurveyAlert = (action, setValues, completeCallback) => {
        let serverParams = {
            loginId: formValues.loginId,
            companyId: formValues.companyId,
            appSurveyKey: setValues.appSurveyKey,
            partnerKey: setValues.partnerKey,
            notCompleted: setValues.notCompleted,
            completed: setValues.completed,
            highScore: setValues.highScore,
            dayOfWeek: setValues.dayOfWeek,
            weekly: setValues.weekly,
            monthly: setValues.monthly,
            yearly: setValues.yearly,
            takeCorrectiveAction: setValues.takeCorrectiveAction,
            completedCorrectiveAction: setValues.completedCorrectiveAction,
            source: "web",
            action: action
        };
        const requestOptions = {
            credentials: "same-origin",
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(serverParams),
        };

        try {
            FetchUtil.fetchAPI("AddUpdateUserPartnerSurveyAlert", "/Service/PartnerSubsService/AddUpdateUserPartnerSurveyAlert", requestOptions, savePartnerSurveyAlertSuccess, savePartnerSurveyAlertFail, completeCallback);
        } catch (error) {
            setError(error.message);
            if (completeCallback) {
                completeCallback();
            }
        }
    };

    function savePartnerSurveyAlertFail(redirect, completeCallback) {
        setError(t("error.userSurveyAlertEditFailed"));
        if (completeCallback) {
            completeCallback();
        }
    }
    function savePartnerSurveyAlertSuccess(responseData, completeCallback) {
        let addUpdateUserPartnerSurveyAlertResponse;
        if (responseData) {
            addUpdateUserPartnerSurveyAlertResponse = responseData.addUpdateUserPartnerSurveyAlertResponse;
            if (addUpdateUserPartnerSurveyAlertResponse) {
                if (addUpdateUserPartnerSurveyAlertResponse.errorCode === "0") {
                    resetRowTable();
                    refreshPartnerSurveyAlert();
                } else {
                    setError(t("error.error") + " " +
                        addUpdateUserPartnerSurveyAlertResponse.errorMessage
                    );
                }
            }
        }
        if (completeCallback) {
            completeCallback();
        }
    }
    function refreshPartnerSurveyAlert() {
        fetchPartnerSurveyAlerts();
    }
    return (
        <>
            {(userCtx.role === "SiteAdmin" || userCtx.role === "ClientAdmin") ?
                <div className="container-fluid container_list_sm viewh-85">
                    <div className="row">
                        <div className="col mt-3">
                            {(error) ? (
                                <div id="inerrorMessage" className="errorblock">
                                    {error}
                                </div>
                            ) : (<></>)}
                        </div>
                        {(isPartnerSurveyAlertLoading || isAppSurveyNameLoading) && (<div> <span class="spinner-border spinner-border-sm spinner-lg-size"></span> </div>)}
                    </div>
                    <div className="row">
                        <div className="col">
                            <div id="placeholder_1" className="placeholder-pg"></div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col">
                            <UserPartnerDD loginId={loginId} companyId={companyId} setSupplierId={setSupplierId} userPartnerList={userPartnerList}
                                supplierId={supplierId} />
                        </div>
                    </div>
                    <div className="row" style={{ margin: "0px" }}>
                        <div className="col">
                            <a class="popup-close" id="boxclose" onClick={(e) => handleClose(e)} ></a>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col">
                            <div id="placeholder_1" className="placeholder-pg"></div>
                        </div>
                    </div>
                    {(supplierId > 0) ?
                        <div className="row">
                            <div className="col">
                                <table className="list-table" role="table">
                                    <thead>
                                        <tr role="row">
                                            <th className="list-th" style={{ maxWidth: "15vw" }}>{t("page.survey.name")}</th>
                                            <th className="list-th" style={{ maxWidth: "10vw" }}>{t("page.freq")}</th>
                                            <th className="list-th" style={{ maxWidth: "9vw" }}>{t("page.dow")}</th>
                                            <th className="list-th" style={{ maxWidth: "9vw" }}>{t("page.alert.notcomplete")}</th>
                                            <th className="list-th" style={{ maxWidth: "9vw" }}>{t("page.alert.complete")}</th>
                                            <th className="list-th" style={{ maxWidth: "9vw" }}>{t("page.alert.highscore")}</th>
                                            <th className="list-th" style={{ maxWidth: "8vw" }}>{t("page.take.corr.action")}</th>
                                            <th className="list-th" style={{ maxWidth: "8vw" }}>{t("page.completed.corr.action")}</th>
                                            <th className="list-th" style={{ maxWidth: "8vw" }}>{t("page.status")}</th>
                                            <th className="list-th" style={{ maxWidth: "15vw" }}>
                                                <button className="btn btn-primary btn-sm me-2 mb-1" onClick={addRowTableTop}>
                                                    {t("page.addRow")}
                                                </button>&nbsp;&nbsp;
                                                <button className="btn btn-primary btn-sm me-2 mb-1" onClick={removeRowTable}>
                                                    {t("page.delRow")}
                                                </button>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody role="rowgroup">
                                        {add && addRowTop &&
                                            <PartnerSurveyAlertTableRow
                                                index={count}
                                                partnerKey={supplierId}
                                                appSurveyNames={appSurveyNames}
                                                handleSubmit={handleSubmit}
                                                setError={setError}
                                                t={t}
                                                setAdd={setAdd}
                                                oddIdx={((partnerSurveyAlerts.length % 2) > 0) ? true : false} />
                                        }
                                        {(partnerSurveyAlerts.length > 0) ? (
                                            partnerSurveyAlerts.map((partnerSurveyAlertItem, index) => (
                                                <PartnerSurveyAlertReadOnlyRow
                                                    index={count}
                                                    t={t}
                                                    partnerSurveyAlertItem={partnerSurveyAlertItem}
                                                    handleDeleteClick={handleDeleteClick}
                                                    oddIdx={((index % 2) > 0) ? true : false}
                                                    add={add}
                                                    setError={setError}
                                                    handleSubmit={handleSubmit}
                                                />
                                            ))
                                        ) : (<></>)}
                                        {add && addRowBottom &&
                                            <PartnerSurveyAlertTableRow
                                                index={count}
                                                partnerKey={supplierId}
                                                appSurveyNames={appSurveyNames}
                                                handleSubmit={handleSubmit}
                                                setError={setError}
                                                t={t}
                                                setAdd={setAdd}
                                                oddIdx={((partnerSurveyAlerts.length % 2) > 0) ? true : false} />
                                        }
                                    </tbody>
                                    {(partnerSurveyAlerts.length > 10) ? (<tfoot>
                                        <tr role="row">
                                            <th className="list-th" style={{ maxWidth: "15vw" }}>{t("page.survey.name")}</th>
                                            <th className="list-th" style={{ maxWidth: "10vw" }}>{t("page.freq")}</th>
                                            <th className="list-th" style={{ maxWidth: "9vw" }}>{t("page.dow")}</th>
                                            <th className="list-th" style={{ maxWidth: "9vw" }}>{t("page.alert.notcomplete")}</th>
                                            <th className="list-th" style={{ maxWidth: "9vw" }}>{t("page.alert.complete")}</th>
                                            <th className="list-th" style={{ maxWidth: "9vw" }}>{t("page.alert.highscore")}</th>
                                            <th className="list-th" style={{ maxWidth: "8vw" }}>{t("page.take.corr.action")}</th>
                                            <th className="list-th" style={{ maxWidth: "8vw" }}>{t("page.completed.corr.action")}</th>
                                            <th className="list-th" style={{ maxWidth: "8vw" }}>{t("page.status")}</th>
                                            <th className="list-th" style={{ maxWidth: "15vw" }}>
                                                <button className="btn btn-primary btn-sm me-2 mb-1" onClick={addRowTableBottom}>
                                                    {t("page.addRow")}
                                                </button>&nbsp;&nbsp;
                                                <button className="btn btn-primary btn-sm me-2 mb-1" onClick={removeRowTable}>
                                                    {t("page.delRow")}
                                                </button>
                                            </th>
                                        </tr>
                                    </tfoot>
                                    ) : (<></>)}
                                </table>
                                <div className="row">
                                    <div className="col mt-3">
                                        {(error) ? (
                                            <div id="inerrorMessage1" className="errorblock">
                                                {error}
                                            </div>
                                        ) : (<></>)}
                                    </div>
                                </div>
                                <div className="footer">
                                    <input
                                        type="button"
                                        name="edit-part-loc-close"
                                        id="edit-part-loc-close"
                                        className="btn btn-secondary btn-block" data-dismiss="modal"
                                        onClick={(e) => handleClose(e)}
                                        style={{ marginTop: "10px", marginBottom: "10px" }}
                                        value={closeText}
                                    ></input>
                                </div>
                            </div>
                        </div> :
                        (!userPartnerList || userPartnerList.length === 0) ?
                            <>
                                <div className="row">
                                    <div className="col mt-3">
                                        <div id="inerrorMessage1" className="errorblock">
                                            {t("error.partnerReqd")}
                                        </div>
                                    </div>
                                </div>
                                <div className="footer">
                                    <input
                                        type="button"
                                        name="edit-part-loc-close"
                                        id="edit-part-loc-close"
                                        className="btn btn-secondary btn-block" data-dismiss="modal"
                                        onClick={(e) => handleClose(e)}
                                        style={{ marginTop: "10px", marginBottom: "10px" }}
                                        value={closeText}
                                    ></input>
                                </div>
                            </> : (<></>)}
                </div>
                : null}
        </>
    );
}
export default PartnerSurveyAlertTable;